// extracted by LIB_CSS_EXTRACT_LOADER
import "./hole-background_module.css"
export default {"root":"root-OfHeSV","canvas":"canvas-tTs4tg","glow":"glow-nZsD4t","scanlines":"scanlines-JVTosf"};